<div class="content">
  <form #feldBeschreibungForm="ngForm" data-qa="feld-beschreibung-form">

    <header>
      <div>

      </div>

      <div class="buttons">

        <button matButton="outlined"
          data-qa="cancel-dienstleistungs-module-button"
          (click)="westnetzSidenavService.closeRightnav()">
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button
            matButton="outlined"
          class="actionbutton"
          (click)="resetForm()"
          [disabled]="!feldBeschreibungForm.form.dirty">
            <mat-icon>autorenew</mat-icon>
          Zurücksetzen
        </button>

        <button matButton="filled"
          [disabled]="!feldBeschreibungForm.form.valid"
          data-qa="submit-dienstleistungs-module-button"
          (click)="save()">
          <mat-icon>save</mat-icon>
          Speichern
        </button>

      </div>
    </header>

    <div class="detail-main">

      <fieldset>
        <legend>Hilfetexte editieren</legend>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Titel</mat-label>
          <input matInput
            maxlength="100"
            #title="ngModel"
            [(ngModel)]="feld.title"
            id="feldbeschreibung_{{feld.id}}"
            name="feldbeschreibung_{{feld.id}}"
            data-qa="feldbeschreibung"
            disabled="disabled"
            required/>
          @if (title?.errors?.required) {
            <mat-error>
              Bitte tragen Sie den Title ein
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Hilfetext</mat-label>
          <textarea matInput
            #hilfetext="ngModel"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            [(ngModel)]="feld.hilfetext"
            id="hilfetext_{{feld.id}}"
            name="hilfetext_{{feld.id}}"
            data-qa="hilfetext"
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="10"
            >
          </textarea>
        </mat-form-field>

      </fieldset>
    </div>
  </form>
</div>
